export const scheduleLaterToday = "HPb";
export const scheduleThisEvening = "IPb";
export const scheduleTomorrow = "JPb";
export const scheduleThisWeekend = "KPb";
export const scheduleNextWeek = "LPb";
export const scheduleChooseDate = "MPb";
export default {scheduleLaterToday,scheduleThisEvening,scheduleTomorrow,scheduleThisWeekend,scheduleNextWeek,scheduleChooseDate};